InspectoresDistritosGridCtrl.$inject = ['$log', '$scope', 'dialogService', '$http'];
export default function InspectoresDistritosGridCtrl($log, $scope, dialogService, $http) {

    var urlTiposBase = Sigo.var.path + '/mantenimiento/inspectoresdistritos';
    var templateDialogo = require('./inspDistAddOrEditDialog.html');
    var templateDialogoBorrar = require('./borrarInspDistDialog.html');

    $scope.anyadirDistrito = function () {
        var titulo = 'Añadir inspector';
        $http.get(urlTiposBase + '/add-or-edit')
            .success(function (data) {
                doDialog(templateDialogo, data, titulo)
                    .then(function (result) {
                        anyadirInspectoresDistritosServer(result);
                    });

            });
    };

    $scope.borrarInspector = function (emailInspector, distrito) {
        var titulo = 'Borrar inspector';
        doDialog(templateDialogoBorrar, [], titulo)
            .then(function () {
                borrarInspectoresDistritosServer(emailInspector, distrito);
            });
    };

    function anyadirInspectoresDistritosServer(inspectorDistrito) {
        $http.post(urlTiposBase + '/add-or-edit', inspectorDistrito)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 1);
            }).error(
            function () {
                Sigo.UI.Messages.open([Lang.get('mensajes.error_mensaje')], 0);
            }
        );
    }

    function borrarInspectoresDistritosServer(emailInspector, distrito) {
        $http.get(urlTiposBase + '/delete/' + emailInspector + '/' + distrito)
            .success(function (data) {
                Sigo.UI.Messages.open(data.messages, 1);
            });
    }

    function doDialog(template, model, titulo) {
        // jQuery UI dialog options
        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 500,
            minHeight: 200,
            //maxHeight: 600,
            close: function () {
                $log.debug("Predefined close");
            }
        };

        var extraOptions = {
            botonOk: ucfirst(Lang.get('nombres.confirmar')),
            botonCancel: ucfirst(Lang.get('nombres.cancelar'))
        };
        // Open the dialog using template from script
        return dialogService.open("dialogTipo", template, model, options, extraOptions);
    }
}